<template>
  <div class="item-content">
        <audio  v-if="videoLocation" ref="player" :src="videoLocation" controls="true"></audio>
  </div>
</template>

<script>

export default {
  uuid: "00000000-0000-0000-0000-000000100003",
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      mediaObject: ""
    }
  },
  computed: {
    videoLocation() {
        return this.datamodel && this.datamodel.value && this.datamodel.value.filelocation
    }
  },
  methods: {
    
  },
  created() {},
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.item-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
    audio {
        // width: 100%;
        flex: 1;
    }
}

</style>
